module.exports = __webpack_public_path__ + "static/media/Leaders.0e03357a.svg";